import React from "react";
import { Box } from "@mui/material";
import SignalCard from "./SignalCard";

export default function SignalRow({ items }) {
  if (!items?.length) return null;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(3, minmax(0, 1fr))" },
        gap: 1,
        mb: 1.15,
      }}
    >
      {items.map((item) => (
        <SignalCard
          key={item.key}
          label={item.label}
          value={item.value}
          tone={item.tone}
          onClick={item.onClick}
        />
      ))}
    </Box>
  );
}
